// extracted by mini-css-extract-plugin
module.exports = {"title":"_1bX5T","memberHeaderRow":"_2fSJB","summary":"_3As4o","description":"_24a1F"};